import {EagleApiInterface, EagleModuleApiInterface} from 'kernel/api/api'

export default (api: EagleApiInterface) => {
  api.collection.providerApi = <EagleModuleApiInterface>{
    read: (id: string) => api.request({
      url: `/api/admin/provider/${id}/read`,
      type: 'get',
    }),
    index: (params = {}) => api.request({
      url: `/api/admin/provider/index`,
      type: 'get',
      params,
    }),
    create: (params = {}) => api.request({
      url: `/api/admin/provider`,
      type: 'post',
      params,
    }),
    update: (id: string, params = {}) => api.request({
      url: `/api/admin/provider/${id}/update`,
      type: 'put',
      params,
    }),
    patch: (id: string, column: string, value: any) => api.request({
      url: `/api/admin/provider/${id}`,
      type: 'patch',
      params: {
        column,
        value,
      },
    }),
    delete: (id: string) => api.request({
      url: `/api/admin/provider/${id}`,
      type: 'delete',
    }),
    batch: (targets: string[], column: string, value: any) => api.request({
      url: `/api/admin/provider/batch`,
      type: 'patch',
      params: {
        ids: targets,
        column,
        value,
      },
    }),
    batchDelete: (targets: string[]) => api.request({
      url: `/api/admin/provider/batch`,
      type: 'delete',
      params: { ids: targets },
    }),
    sendVerify: (id: string) => api.request({
      url: `/api/admin/provider/${id}/send-verify`,
      type: 'post',
    }),
    verify: (provider_id: string) => api.request({
      url: `/api/admin/provider/${provider_id}/verify`,
      type: 'post',
    }),
    bindAdmin: (provider_id: string, memberId: string, type: string) => api.request({
      url: `/api/admin/provider/${provider_id}/master/${memberId}`,
      type: 'put',
      params: { type },
    }),
  }

}
